import React from "react";
import "./MeduimCard.css";
const MeduimCard = ({ img, title }) => {
  return (
    <div
      className="main-box cursor-pointer hover:scale-105 
    transform transition duration-300 ease-out"
    >
      <img src={img} alt="cake" />

      <h3 className="text">{title}</h3>
    </div>
  );
};

export default MeduimCard;
